import { WS_MESSAGE_TYPE, WS_NOTIFICATION_KINDS } from 'cpool-constants';
import { z } from 'zod';

// bell push on `ws:user-notify:{userId}` - without `position` the query is just invalidated
export const schemaWsNotificationsMessage = z.object({
    kind: z.nativeEnum(WS_NOTIFICATION_KINDS),
    position: z.number().int().optional(),
    type: z.literal(WS_MESSAGE_TYPE.NOTIFICATIONS),
});

export type Schema_WsNotificationsMessage = z.infer<typeof schemaWsNotificationsMessage>;
